import {gql} from "@apollo/client";

export const GQL_ANALYZER_REPORT_PDF_QUERY = gql`
  query AnalyzerReportPdf($report: JSON!, $thread_id: String) {
    analyzerReportPdf(report: $report, thread_id: $thread_id) {
      data
      filename
    }
  }
`;
